var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2725 10.25C26.7787 10.25 28 11.4713 28 12.9775V23.8867C27.9998 25.3928 26.7786 26.6133 25.2725 26.6133H24.5898L25.8174 28.25C26.0432 28.5512 25.9819 28.9782 25.6807 29.2041C25.3794 29.4299 24.9525 29.3686 24.7266 29.0674L22.8857 26.6133H18.1133L16.2715 29.0674C16.0456 29.3686 15.6186 29.4299 15.3174 29.2041C15.0164 28.9781 14.9559 28.5511 15.1816 28.25L16.4092 26.6133H15.7275C14.2214 26.6133 13.0002 25.3928 13 23.8867V12.9775C13 11.4713 14.2213 10.25 15.7275 10.25H25.2725ZM14.3633 23.8867C14.3635 24.6397 14.9745 25.25 15.7275 25.25H25.2725C26.0255 25.25 26.6365 24.6397 26.6367 23.8867V19.7959H14.3633V23.8867ZM16.75 21.8408C17.3148 21.8408 17.7734 22.2985 17.7734 22.8633C17.7734 23.4281 17.3148 23.8857 16.75 23.8857C16.1853 23.8856 15.7275 23.428 15.7275 22.8633C15.7276 22.2985 16.1853 21.841 16.75 21.8408ZM24.25 21.8408C24.8148 21.8408 25.2734 22.2985 25.2734 22.8633C25.2734 23.4281 24.8148 23.8857 24.25 23.8857C23.6853 23.8856 23.2275 23.428 23.2275 22.8633C23.2276 22.2985 23.6853 21.841 24.25 21.8408ZM14.3633 18.4316H19.8184V15.0225H14.3633V18.4316ZM21.1826 18.4316H26.6367V15.0225H21.1826V18.4316ZM15.7275 11.6133C14.9744 11.6133 14.3633 12.2244 14.3633 12.9775V13.6582H26.6367V12.9775C26.6367 12.2244 26.0256 11.6133 25.2725 11.6133H15.7275Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubway);
export default __webpack_public_path__ + "static/media/ic_subway.d7c4b1e266435b93f8509a257bdbcb64.svg";
export { ForwardRef as ReactComponent };